export enum OrderType {
  openOrder = 'OPEN_ORDERS',
  history = 'HISTORY'
}

export enum OrderUserType {
  buyer = 'BUYER',
  seller = 'SELLER'
}